import React, { useCallback, useEffect, useState } from 'react';
import './styles.css';
import { PortfolioItem } from 'src/components/PortfolioItem/PortfolioItem';

const portfolioItems = [
  { src: '/portfolio/fairway.png', alt: 'xxx' },
  { src: '/portfolio/off-to-the-races.png', alt: 'xxx' },
  { src: '/portfolio/woodbridge-athletic-club.png', alt: 'xxx' },
  { src: '/portfolio/four-stars.png', alt: 'xxx' },
  { src: '/portfolio/crybaby-menu-cover.png', alt: 'xxx' },
  { src: '/portfolio/comeback-kid.png', alt: 'xxx' },
  { src: '/portfolio/eugenie-postcard.png', alt: 'xxx' },
  { src: '/portfolio/pure-danforth.png', alt: 'xxx' },
  { src: '/portfolio/resting-bitch-face.png', alt: 'xxx' },
  { src: '/portfolio/tigre-1.png', alt: 'xxx' },
  { src: '/portfolio/negroni.png', alt: 'xxx' },
  { src: '/portfolio/chickadeeroom.jpg', alt: 'xxx' },
  { src: '/portfolio/postcard.png', alt: 'xxx' },
  { src: '/portfolio/dear-friend.png', alt: 'xxx' },
];

const sidebarText = 'BADARTGOODLUCK***PORTFOLIO***';
const sidebarTextRepeated = sidebarText.repeat(50);
const sideBarTextRepeatedChars = sidebarTextRepeated.split('').map((char, index) => (
  <span key={index} className="sidebar-char">
    {char}
  </span>
));

export const Portfolio = () => {
  const [maxPortfolioHeight, setMaxPortfolioHeight] = useState('unset');

  const onWindowScroll = useCallback(() => {
    const container = document.querySelector('.container');
    const leftSideRotation = container.scrollTop * 0.1;
    const rightSideRotation = container.scrollTop * 0.1;

    const leftSide = document.querySelector('.left-side');
    const rightSide = document.querySelector('.right-side');

    if (leftSide) {
      leftSide.style.setProperty('--rotate-left-side', `${leftSideRotation}deg`);
    }
    if (rightSide) {
      rightSide.style.setProperty('--rotate-right-side', `${rightSideRotation}deg`);
    }


    const portfolioItemsElement = document.querySelector('.portfolio-items');
    const imagesHeight = portfolioItemsElement ? portfolioItemsElement.getBoundingClientRect().height : 0;
    if (imagesHeight !== maxPortfolioHeight && imagesHeight > 0) {
      setMaxPortfolioHeight(imagesHeight);
    }
  }, [maxPortfolioHeight]);

  useEffect(() => {
    const container = document.querySelector('.container');
    container.addEventListener('scroll', onWindowScroll);

    return () => {
      container.removeEventListener('scroll', onWindowScroll);
    };
  }, [onWindowScroll]);

  return (
    <div className="portfolio-page" style={{maxHeight: maxPortfolioHeight, overflow: 'hidden'}}>
      <div className="portfolio-inner">
        <div className="left-side">{sideBarTextRepeatedChars}</div>
        <div className="portfolio-items">
          {portfolioItems.map((item, index) => (
            <PortfolioItem key={index} src={item.src} alt={item.alt} />
          ))}
        </div>
        <div className="right-side">{sideBarTextRepeatedChars.reverse()}</div>
      </div>
    </div>
  );
};
